/* global Office */

/**
 * OS の既定ブラウザで指定 URL を開く Office.js ラッパー。
 *
 * - `Office.context.ui.openBrowserWindow` は Office アドインから外部ブラウザを起動する
 *   公式 API。リクエスト時のクッキー領域は WebView2 と完全分離されるため、ブラウザ側で
 *   独立した認証セッションを持つ。
 * - **必ずユーザー操作 (リボンクリック等) ハンドラ内で同期的に呼び出すこと。** 非同期処理を
 *   挟むと一部 OS 上でポップアップブロックの対象になり得る。
 */
export function openBrowserWindow(url: string): void {
    Office.context.ui.openBrowserWindow(url);
}
